import { Text } from '@/components/text';
import { NumberInput } from '@/components/ui/number-input';
import { Colors } from '@/constants/theme';
import { useScenarioStore } from '@/stores/scenario-store';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

export function PartnerMarginInput() {
  const { t } = useTranslation();
  const inputs = useScenarioStore(s => s.inputs);
  const setField = useScenarioStore(s => s.setField);
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
      <Text
        style={{
          fontSize: 13,
          fontWeight: '600',
          color: isFocused ? Colors.light.primary : Colors.light.secondaryText,
        }}>
        {t('onboarding.summary.margin')}
      </Text>
      <View style={{ width: 50 }}>
        <NumberInput
          size='sm'
          label={''}
          value={inputs.partnerMargin}
          placeholder='25'
          suffix='%'
          min={0}
          max={100}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={v => setField('partnerMargin', v ?? 0)}
        />
      </View>
    </View>
  );
}
